import {ReactElement} from "react";

const CX = 80;
const CY = 80;
export const LETTER_INDICATOR_R = 57;
export const PLAYER_INDICATOR_R = 64;

interface ICompassEntry {
    angle: number
    opacity: number
    radius: number
    children: ReactElement
}
export function CompassEntry({angle, opacity, radius, children}: ICompassEntry) {
    const x = CX + Math.cos(angle) * radius;
    const y = CY + Math.sin(angle) * radius;
    return (
        <div style={{
            position: "absolute",
            left: x,
            top: y,
            transform: "translate(-50%, -50%)",
            opacity,
            transition: "left 0.4s ease-out, top 0.4s ease-out, opacity 0.3s linear",
            pointerEvents: "none"
        }}>
            {children}
        </div>
    );
}
